import { Question } from '../../../types';
import { MaxLimitField, TagsField } from '../../components';

interface TextQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function TextQuestionConfig({ question, onEdit }: TextQuestionConfigProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <MaxLimitField
        label="Máx. caracteres"
        value={question.maxCharacters || 0}
        onChange={(value) => {
          const updates: Partial<Question> = {};
          if (value) {
            updates.maxCharacters = value;
          }
          onEdit(question.id, updates);
        }}
        placeholder="Ilimitado"
      />
      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
